<template>
    <client-page>

        <sub-visual
        sh="About IST"
        tabActive="Partners"
        bg="/images/sub/visual/sv1.png">
        </sub-visual>

        <section class="sub-section sub-section--first">
            <v-container>
                <h2 class="page-tit">
                    Partners
                </h2>
            </v-container>
            <top-image
            src="/images/sub/about/partner/partner-img.png">
            </top-image>
        </section>
        
        <section class="sub-section sub-section--last">
            <v-container>
                <v-row class="my-n10 ma-lg-n30">

                    <partner
                    company="SK Hynix"
                    src="/images/sub/about/partner/logo1.png"
                    width="96">
                    </partner>

                    <partner
                    company="EBARA in Korea"
                    src="/images/sub/about/partner/logo2.png"
                    width="177">
                    </partner>

                    <partner
                    company="DUPONT KALREZ"
                    src="/images/logos/kalrez.png"
                    width="290"
                    dupont>
                    </partner>

                    <partner
                    company="KCTech"
                    src="/images/sub/about/partner/logo4.png"
                    width="249">
                    </partner>

                    <partner
                    company="EHWA DIAMOND"
                    src="/images/sub/about/partner/logo5.png"
                    width="177">
                    </partner>

                    <partner
                    company="DUPONT VESPEL"
                    src="/images/logos/vespel.png"
                    width="270"
                    dupont>
                    </partner>

                    <partner
                    company="ENDO - MFG"
                    src="/images/sub/about/partner/logo7.png"
                    width="175">
                    </partner>

                    <partner
                    company="Mitsubishi Cable Industries"
                    src="/images/sub/about/partner/logo6.png"
                    width="359">
                    </partner>
                    
                </v-row>
            </v-container>
        </section>

    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/ko/templates/ClientPage.vue";
import SubVisual from "@/components/client/ko/sub/sub-visual.vue";
import TopImage from "@/components/client/ko/sub/sub-top-image.vue";
import Partner from "@/components/client/ko/sub/sub-partner.vue";
export default {
    components: {
        ClientPage,
        SubVisual,
        TopImage,
        Partner,
    },
};
</script>

<style lang="scss" scoped>
</style>